'use strict';

bbw.service.WindowTitleSvc = Class({

    $inject: ['$rootScope'],

    construct: function($rootScope) {
        this.$rootScope = $rootScope;
    },

    setWindowTitle: function(title, args, raw) {
        this.$rootScope.$broadcast('bbwSetPageTitle', {
            title: title,
            args: args,
            raw: !!raw
        });
    }

});
